import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { InputFileComponent } from './components/input-file.component';
import { InputFileConfig } from './interfaces/input-file-config';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DragDropDirective } from './directives/drag-drop.directive';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropZoneDirective } from './directives/drop-zone.directive';
import { PublicImageOrderComponent } from './public-image-order/public-image-order.component';

@NgModule({
  declarations: [
    InputFileComponent,
    DragDropDirective,
    DropZoneDirective
  ],
  imports: [
    CommonModule,
    DragDropModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    PublicImageOrderComponent
  ],
  exports:[
    InputFileComponent,
    PublicImageOrderComponent,
    DragDropDirective,
    DropZoneDirective,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule
  ]
})

export class InputFileModule { 
  public static forRoot(config: InputFileConfig): ModuleWithProviders<InputFileModule> {
    return {
        ngModule: InputFileModule,
        providers: [
            { provide: 'config', useValue: config }
        ]
    };
  }
}
